import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { Field } from "@/components/Field";
import { FormDialog, useSubmit, num } from "./FormDialog";

export const AdjustDialog = ({ open, onOpenChange, lot, unit, onSaved }) => {
  const [delta, setDelta] = useState("");
  const [reason, setReason] = useState("");
  const { saving, run } = useSubmit();
  useEffect(() => {
    if (open) { setDelta(""); setReason(""); }
  }, [open]);

  const submit = () =>
    run(async () => {
      await api.post("/movements/adjust", { lot_id: lot.id, delta: num(delta), reason });
      onOpenChange(false);
      onSaved?.();
    }, "Rettifica registrata");

  return (
    <FormDialog open={open} onOpenChange={onOpenChange} title="Rettifica giacenza" description="Usa un valore negativo per diminuire (es. -2). La rettifica resta nello storico con motivo e autore." onSubmit={submit} saving={saving} testId="adjust-dialog" submitLabel="Registra rettifica">
      <Field label={`Variazione (${unit}) *`}><Input data-testid="adjust-delta-input" type="number" step="any" required value={delta} onChange={(e) => setDelta(e.target.value)} className="h-11" /></Field>
      <Field label="Motivo *"><Input data-testid="adjust-reason-input" required minLength={3} value={reason} onChange={(e) => setReason(e.target.value)} className="h-11" /></Field>
    </FormDialog>
  );
};
